import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { DateFormate, CommonConstant, NoRecordFound, TestResult } from 'src/app/constants/common-constant';
import { TestConstant } from 'src/app/constants/label-constants';
import { StudentModel } from 'src/app/models/testModel';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { TestDetailComponent } from '../test-detail/test-detail.component';
import * as saveAs from 'file-saver';
import { RestartExamComponent } from '../../restart-exam-dialogbox/restart-exam/restart-exam.component';
import { PendingStudentComponent } from '../pending-student/pending-student.component';
import { formatDate } from '@angular/common';
import { Location } from '@angular/common';
import { DeleteDialogboxComponent } from '../../delete-dialogbox/delete-dialogbox.component';

@Component({
  selector: 'app-test-student-view',
  templateUrl: './test-student-view.component.html',
  styleUrls: ['./test-student-view.component.scss']
})
export class TestStudentViewComponent {
  StudentList: any = [];
  closeResult = '';
  enterSearch: string = '';
  searchClose: boolean = false;
  SortColumn: any = '';
  sortDirection: any = '';
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  TestName: string = '';
  TestDuration: string = '';
  StartTime: string = '';
  EndTime: string = '';
  TestDate: string = '';
  resultFilter: string = '';
  submitTypeFilter: string = '';
  showData: boolean = false;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  displayedColumns: string[] = ['rowNumber', 'studentName','EmailId','MobileNo', 'startTime', 'endTime', 'wrong', 'markScores', 'result', 'submitType', 'Action'];
  dataSource: MatTableDataSource<StudentModel> = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  isSubmitted: boolean = false;
  navigateFlag: boolean = false;
  submitted: boolean = false;
  cutoff: number = 0;
  studentResultDeleteObj: any = {};
  dateConstant: any = [];
  TestConstant: any = [];
  CommonConstant: any = [];
  NoRecordFound: any = [];
  TestResult: any = [];
  TestId: number = 0;
  currentDateTime: any;
  testResult: boolean = false;
  exportButton: boolean = true;
  resultList: any = [
    {
      'id': 0,
      'value': 'Fail'
    }, {
      'id': 1,
      'value': 'Pass'
    }, {
      'id': 2,
      'value': 'Final'
    }];

  SubmitTypeList: any = [
    {
      'id': 'start',
      'value': 'Start'
    }, {
      'id': 'background',
      'value': 'Background'
    },
    {
      'id': 'submit',
      'value': 'Submit'
    },
    {
      'id': 'timeout',
      'value': 'Timeout'
    },
    {
      'id': 'resubmission',
      'value': 'Resubmission'
    }
  ];

  constructor(
    public commonService: CommonService,
    public toster: ToastrService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private sharedService: SharedService,
    private router: Router,
    private modalService: NgbModal,
    private EncrDecr: EncrDecrService,
    private route: ActivatedRoute,
    private changeDetectorRefs: ChangeDetectorRef,
    private _location: Location
  ) { }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.dateConstant = DateFormate;
    this.TestConstant = TestConstant;
    this.CommonConstant = CommonConstant;
    this.NoRecordFound = NoRecordFound;
    this.TestResult = TestResult;
    this.route.params.subscribe((params) => {
      if (params['id'] !== undefined) {
        var decrypted = params['id'] ? params['id'] : '';
        this.TestId = Number(this.EncrDecr.get('123456$#@$^@1ERF', decrypted));
      }
    })
    if (this.TestId > 0) {
      this.getTestDetailById(this.TestId)
      this.getTestDeatils(this.TestId);
    }
    else {
      this.TestId = 0;
    }
    this.sharedService.setData('Student List');
  }

  backButtoEvent() {
    this._location.back();
  }

  getTestDetailById(testId: number) {
    const apiUrl = this.apiUrl.apiUrl.test.EditTestData.replace("{examId}", testId.toString());
    this.commonService.doGet(apiUrl).pipe().subscribe({
      next: async (response) => {
        if (response.success) {
          this.TestName = response.data.examName;
          this.TestDuration = this.timeConvert(response.data.durationInMins);
          this.StartTime = response.data.startTime
          this.EndTime = response.data.endTime;
          this.TestDate = response.data.examDate;
          this.cutoff = response.data.cutOff;
          this.currentDateTime = formatDate(new Date(), 'dd/MM/yyyy', 'en');
          const date = formatDate(this.TestDate, 'dd/MM/yyyy', 'en')
          if (date >= this.currentDateTime) {

            this.testResult = true;
          }
          else {
            this.testResult = false;
          }
        }
        else {
          this.toster.error(response.message);
        }
      },
      error: (error) => {
        this.spinner.hide();
      }
    });
  }

  getTestDeatils(testId: number) {
    this.showData = false;
    const objData = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection,
      ExamId: testId,
      Filter: this.resultFilter,
      SubmitTypeFilter: this.submitTypeFilter
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.test.GetTestResultById;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        this.spinner.hide();
        if (response.success) {
          this.spinner.hide();
          this.showData = true;
          let TotalRecords = 0;
          this.StudentList = response.data
          this.dataSource.data = this.StudentList;
          
          if (this.StudentList.length > 0) {
            TotalRecords = this.StudentList[0].totalRecords;
            this.totalRows = TotalRecords;
            this.exportButton = true;
          }
          else {
            this.exportButton = false;
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = TotalRecords;
          });
        }
        else {
          this.spinner.hide();
          this.exportButton = false;
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.exportButton = false;
      }
    });
  }

  onSelectChange(result: string) {
    this.resultFilter = result;
    this.getTestDeatils(this.TestId);
  }

  onSubmitTypeChanages(SubmitType: string) {
    this.submitTypeFilter = SubmitType
    this.getTestDeatils(this.TestId);
  }

  pageChanged(event: { pageSize: number; pageIndex: number; }) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getTestDeatils(this.TestId);
  }

  SortChange(event: { direction: string; active: any; }) {
    this.sortDirection = event.direction == '' ? 'asc' : event.direction;
    this.SortColumn = event.active;
    this.getTestDeatils(this.TestId);
  }

  search(event) {
    if (event.target.value == '') {
      this.enterSearch = '';
      this.currentPage =0;
      this.getTestDeatils(this.TestId);
      this.searchClose = false;
    }
    else {
      this.searchClose = true;
    }
    if (event.key === "Enter" && event.target.value != '') {
      this.currentPage =0;
      this.enterSearch = event.target.value;
      this.getTestDeatils(this.TestId);
      this.searchClose = true;
    }
  }

  cancelSearch(): void {
    this.enterSearch = '';
    this.getTestDeatils(this.TestId);
    this.searchClose = false;
  }

  sanitizeInput(event: any) {
    const inputElement: HTMLInputElement = event.target;
    const sanitizedValue: string = inputElement.value.replace(/\D/g, '');
    inputElement.value = sanitizedValue;
  }

  PendingResult() {
    const modalRef = this.modalService.open(PendingStudentComponent, { centered: true, backdrop: 'static', keyboard: false, size: 'xl', modalDialogClass: 'modal-widthchange' });
    modalRef.componentInstance.testId = this.TestId;
    modalRef.componentInstance.testName = this.TestName;
  }

  ExportResult() {
    const objData = {
      ExamId: this.TestId,
      Filter: this.resultFilter
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.test.ExportTestResultById;
    this.commonService.DownloadCSVFile(apiUrl, objData).subscribe(
      (buffer) => {
        if (buffer != null) {
          if (buffer.size != 0) {
            const data: Blob = new Blob([buffer], {
              type: "text/csv;charset=utf-8"
            });
            saveAs(data, this.TestName + ' Student-Result.xlsx');
            this.spinner.hide();
          } else {
            this.spinner.hide();
            this.toster.error(CommonConstant.FileNotFound);
          }
        } else {
          this.spinner.hide();
          this.toster.error(CommonConstant.NoRecordFound)
        }
      },
      error => {
        this.spinner.hide();
        this.commonService.checkAuthorize(error);
      });
  }

  RefreshGrid() {
    this.resultFilter = '';
    this.submitTypeFilter = '';
    this.enterSearch = '';
    this.searchClose = false;
    this.showData = false;
    const objData = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection,
      ExamId: this.TestId,
      Filter: this.resultFilter
    }
    const apiUrl = this.apiUrl.apiUrl.test.GetTestResultById;
    this.spinner.hide();
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        this.spinner.hide();
        if (response.success) {
          this.showData = true;
          let TotalRecords = 0;
          this.StudentList = response.data
          this.dataSource.data = this.StudentList;

          this.spinner.hide();
          if (this.StudentList.length > 0) {
            TotalRecords = this.StudentList[0].totalRecords;
            this.totalRows = TotalRecords;
          }
        }
      }
    });
    this.changeDetectorRefs.detectChanges();
  }

  timeConvert(n: number) {
    var hours = (n / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    if (rhours == 0) {
      return rminutes + " min"
    }
    else if (minutes == 0) {
      return rhours + " hr";
    }
    else {
      return rhours + " hr : " + rminutes + " min";
    }
  }

  TestDetail(testId: number) {
    const modalRef = this.modalService.open(TestDetailComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.testId = testId;
    modalRef.result.then((result) => {
    }).catch((error) => {
    });
  }

  ViewResult(testSubmitId: number) {
    var encrypted = this.EncrDecr.set('123456$#@$^@1ERF', testSubmitId);
    this.router.navigate(['exam/studentresult/', encrypted]);
  }

  Restart(id: any, studentName: any,studentId:number) {
    const modalRef = this.modalService.open(RestartExamComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.studentName = studentName;
    modalRef.componentInstance.studentId = studentId;
    modalRef.componentInstance.examId = this.TestId;
  }

  Deletepopup(examSubmitId: number, studentName: string) {
    const modalRef = this.modalService.open(DeleteDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.studentResultDeleteObj = {
      testId: examSubmitId,
      studentName: studentName,
      element: 'student result'
    }
    modalRef.componentInstance.studentResultDeleteObj = this.studentResultDeleteObj;
    modalRef.result.then((result) => {
      if (result === 'delete') {
        this.spinner.hide();
        this.getTestDeatils(this.TestId);
      }
    }).catch((error) => {
    });
  }

  downloadPdf() {
    this.spinner.show();
    const url = this.apiUrl.apiUrl.test.ExportPdf;
    const objData = {
      ExamId: this.TestId,
      Filter: this.resultFilter
    }
    this.commonService.DownloadPDFFilePost(url,objData).subscribe(
      (buffer: Blob) => {
        if (buffer != null) {
          if (buffer && buffer.size > 0) {
            const blob = new Blob([buffer], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = this.TestName + ' Student-Result.pdf';
            a.click();
            URL.revokeObjectURL(blobUrl);
            this.spinner.hide();
          } else {
            this.spinner.hide();
            this.toster.error(CommonConstant.NoRecordFound)
          }
        }
        else {
          this.spinner.hide();
          this.toster.error(CommonConstant.NoRecordFound)
        }
      },
      (error) => {
        console.error('Error:', error);
        this.spinner.hide();
      }
    );
  }
  getDate(passDate) {
    let resultdate = new Date(passDate);
    return resultdate;
  }
}